<div class=outer>
<layout>
        <div class="container">
        <div class=first>
                <div class="titles">
                        <h2 class="title"   >{{config?.whatCanIExpect}}</h2>
                        <p  > {{config?.para1}}</p>
                        <p  > {{config?.para2}}</p>
                        <gradient-button *ngIf="!profile?.currentLesson"  (click)=register()>{{config?.mainStartButton}}</gradient-button>
                        <gradient-button *ngIf="profile?.currentLesson" (click)=register()>{{config?.resume}} {{profile?.currentLesson}}</gradient-button>
                </div>
        </div>
        <div class=second>
        <img 
                src="../../../assets/Images/Box.jpg" 
                 
                class="box" 
                alt="Bible Study Guides Box" />        
        </div>
        </div>
<div class="container-1">
        <div class="first">
                <span class=subheader >{{config?.topicsTitle}}</span>
                <div class="card-container" routerLink="/my-lessons">
                        
                        <app-lesson-card id="3"    ></app-lesson-card>
                        <app-lesson-card id="10"   ></app-lesson-card>
                        <app-lesson-card id="15"   ></app-lesson-card>
                        <app-lesson-card id="19"   ></app-lesson-card>
                        <app-lesson-card id="20"   ></app-lesson-card>
                </div>

                <span class="mm"  ></span>
                

        </div>
        <div class="second">

                <img 
                        src="../../../assets/Images/lessons.jpg" 
                        class="box-1" 
                        alt="Bible Study Guides Box" />
        
                <gradient-button *ngIf="!profile?.currentLesson"  (click)=register()>{{config?.mainStartButton}}</gradient-button>
                <gradient-button *ngIf="profile?.currentLesson" (click)=register()>{{config?.resume}} {{profile?.currentLesson}}</gradient-button>

        </div>
        
</div>	
</layout>

</div>